import { Header } from "../components/site/Header";
import { Hero } from "../components/site/Hero";
import { Marquee } from "../components/site/Marquee";
import { Formules } from "../components/site/Formules";
import { Comparatif } from "../components/site/Comparatif";
import { Etapes } from "../components/site/Etapes";
import { Faq } from "../components/site/Faq";
import { About } from "../components/site/About";
import { Contact } from "../components/site/Contact";
import { FinalCta } from "../components/site/FinalCta";
import { Footer } from "../components/site/Footer";

export default function HomePage() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Marquee />
        <Formules />
        <Comparatif />
        <Etapes />
        <Faq />
        <About />
        <Contact />
        <FinalCta />
      </main>
      <Footer />
    </>
  );
}
